"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachedControlList = exports.AttachedControl = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var buttons_1 = require("../buttons");
var deadline_1 = require("../editableList/deadline");
var generic_1 = require("../generic");
var AttachedControl = (function (_super) {
    __extends(AttachedControl, _super);
    function AttachedControl(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            actions: 0
        };
        return _this;
    }
    AttachedControl.prototype.componentDidMount = function () {
        var _this = this;
        ajax_get_control_actions(this.props.control.id, function (result) {
            _this.setState({ actions: result });
            update_show_all_actions();
        });
        $("#show_done_discarded_actions_" + this.props.control.id).on("change", function () {
            ajax_get_control_actions(_this.props.control.id, function (result) {
                _this.setState({ actions: result });
                update_show_all_actions();
            });
        });
    };
    AttachedControl.prototype.render = function () {
        var self = this;
        var props = this.props;
        var control = props.control;
        return (React.createElement("div", { id: "control_".concat(self.props.control.id), className: "mb-2" },
            React.createElement("div", { className: "AttachedControl row pt-2" },
                React.createElement("div", { className: "col-12 col-md-7 font-weight-bold", onClick: function () { return self.onClick(); } },
                    "#",
                    control.control_number,
                    " - ",
                    control.status_display),
                React.createElement("div", { className: "col-10 col-md-4", onClick: function () { return self.onClick(); } },
                    React.createElement(deadline_1.default, { date: control.deadline, urgency: control.urgency }),
                    control.next_deadline && (React.createElement(React.Fragment, null,
                        ' ',
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.arrow_circle_right, prefix: "far" }),
                        ' (',
                        React.createElement("time", null, control.next_deadline),
                        ')'))),
                React.createElement("div", { className: "col-2 col-md-1 text-right", onClick: function () { return self.onClick(); } }, control.has_comments ? (React.createElement(generic_1.Icon, { name: generic_1.Icons.circle, prefix: "fas", size: "xs" })) : (React.createElement(generic_1.Icon, { name: generic_1.Icons.circle, prefix: "far", size: "xs" }))),
                React.createElement("div", { className: "col-12 col-md-7", onClick: function () { return self.onClick(); } }, control.description),
                React.createElement("div", { className: "col-12 col-md-5", onClick: function () { return self.onClick(); } }, control.assigned_to_full_name),
                React.createElement("div", { className: "col-8" },
                    React.createElement("div", { className: "row" },
                        React.createElement(buttons_1.ActionButton, { className: "btn btn-link actions_toggle" },
                            React.createElement("span", { className: "Actions__Toggle--Icon" }, self.state.actions > 0 ? (React.createElement(generic_1.Icon, { name: generic_1.Icons.caret_down })) : (React.createElement(generic_1.Icon, { name: generic_1.Icons.angle_down }))),
                            " ",
                            gettext("Actions"),
                            " ",
                            React.createElement("span", { className: "badge badge-pill badge-secondary" }, self.state.actions)),
                        React.createElement("div", { className: "custom-control custom-switch mt-2" },
                            React.createElement("input", { type: "checkbox", className: "custom-control-input", id: "show_done_discarded_actions_" + control.id }),
                            React.createElement("label", { className: "custom-control-label", htmlFor: "show_done_discarded_actions_" + control.id }, gettext("Show done/discarded actions"))))),
                React.createElement("div", { className: "col-4 text-right" },
                    React.createElement(buttons_1.ActionButton, { className: "btn btn-link add_action" },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                        " ",
                        gettext("Add action")))),
            React.createElement("div", { className: "row actions d-none" })));
    };
    AttachedControl.prototype.onClick = function () {
        var props = this.props;
        App_1.store.controlDialog.openDialog(props.control);
    };
    AttachedControl = __decorate([
        mobx_react_1.observer
    ], AttachedControl);
    return AttachedControl;
}(React.Component));
exports.AttachedControl = AttachedControl;
var AttachedControlList = (function (_super) {
    __extends(AttachedControlList, _super);
    function AttachedControlList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { showDone: false, showDiscarded: false };
        return _this;
    }
    AttachedControlList.prototype.toggle_done = function () {
        this.setState({ showDone: !this.state.showDone });
    };
    AttachedControlList.prototype.toggle_discarded = function () {
        this.setState({ showDiscarded: !this.state.showDiscarded });
    };
    AttachedControlList.prototype.componentDidMount = function () {
        var self = this;
        jQuery("#show_done").on("change", function (event) {
            self.toggle_done();
        });
        jQuery("#show_discarded").on("change", function (event) {
            self.toggle_discarded();
        });
    };
    AttachedControlList.prototype.componentWillUnmount = function () {
        jQuery("#show_done").off("change");
        jQuery("#show_discarded").off("change");
    };
    AttachedControlList.prototype.render = function () {
        var state = this.state;
        var openStatuses = [10, 20, 30];
        var closedStatuses = [40, 50];
        var open = this.props.controls.filter(function (control) { return openStatuses.indexOf(control.status) >= 0; });
        var done = this.props.controls.filter(function (control) { return control.status === 40; });
        var discarded = this.props.controls.filter(function (control) { return control.status === 50; });
        return (React.createElement("div", { className: "AttachedControlList container-fluid", ref: function (div) {
                $(div).undelegate();
                $(div).delegate("button.actions_toggle", "click", action_toggle_handler);
            } },
            open.map(function (control) {
                return React.createElement(AttachedControl, { key: control.id, control: control });
            }),
            state.showDone &&
                done.map(function (control) {
                    return React.createElement(AttachedControl, { key: control.id, control: control });
                }),
            state.showDiscarded &&
                discarded.map(function (control) {
                    return React.createElement(AttachedControl, { key: control.id, control: control });
                })));
    };
    AttachedControlList = __decorate([
        mobx_react_1.observer
    ], AttachedControlList);
    return AttachedControlList;
}(React.Component));
exports.AttachedControlList = AttachedControlList;
